module.exports = __webpack_public_path__ + "static/media/unity.948483a5.png";